import React, { useState, useContext } from 'react'
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Button, Container, MenuItem, Paper, Select, Typography } from '@mui/material';
import { FiscalYearListType, useInit } from '../DataFetch/useInit';
import { DownloadCertificateFile, DownloadWorkFile } from '../DataFetch/ManagementAPI';
import { SessionContext } from '../ManagementRoot';

export function WorkAndCertificate() {

    const {init} = useInit();

    const [currentYear, setCurrentYear] = useState(init?.fiscalyear);

    const ConfirmSession = useContext(SessionContext);

    async function DownloadWork() {

        if(!await ConfirmSession()) {
            return;
        }

        DownloadWorkFile(currentYear);
    }

    async function DownloadCertificate() {

        if(!await ConfirmSession()) {
            return;
        }

        DownloadCertificateFile(currentYear);
    }

    return(
        <>
            <Typography
                variant="h6"
            >
                作品と在籍証明
            </Typography>
            <Grid2 xs={12}>
                <Paper>
                    <Container maxWidth="sm">
                        <Box p={2}>                         
                            <Typography
                                variant="body1"
                                p={1}
                            >
                                対象年度
                            </Typography>
                            <Select
                                defaultValue={init?.fiscalyear.toString()}
                                onChange={e => e.target.value !== currentYear ? setCurrentYear(e.target.value) : ""}
                                value={currentYear}
                            >
                                {
                                    init?.fiscal_year_list.map((value:FiscalYearListType, index:number) =>(
                                        <MenuItem key={index} value={value.target_year}>
                                            {value.target_year}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                            <Box p={2}>
                                <Button variant="contained" 
                                    onClick={DownloadWork}
                                >
                                    作品ダウンロード
                                </Button>
                            </Box>     
                            <Box p={2}>
                            <Button variant="contained" 
                                    onClick={DownloadCertificate}
                                >
                                    在籍証明ダウンロード
                                </Button>
                            </Box>                 
                        </Box>
                    </Container>
                </Paper>
            </Grid2>
        </>
    );
}